export default __webpack_public_path__ + "static/media/myprofile.22363880.png";